/**
 * Loading Spinner Component
 * Zeigt einen Ladeindikator während Seiten geladen werden
 */

const LoadingSpinner = () => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-dark">
      <div className="relative">
        <div className="w-16 h-16 border-4 border-primary/20 border-t-primary rounded-full animate-spin"></div>
        <div className="mt-4 text-center">
          <p className="text-white font-body text-sm">Laden...</p>
        </div>
      </div>
    </div>
  );
};

export default LoadingSpinner;
